// データ一覧表示で利用するテーブルのコンポーネント定義
import { TableCell, withStyles } from '@material-ui/core';
// 表のヘッダのセル用
export const ListTableHeaderCell = withStyles({
  root: {
    backgroundColor: '#0099CC',
    color: '#fff',
    fontSize: 16
  },
  expanded: {}
})(TableCell);
